module.exports = __webpack_public_path__ + "media/icons/section_b@3x-b6386f97.svg";